import { format } from 'date-fns';
import { ca } from 'date-fns/locale';import { FunctionField, useNotify, Button } from 'react-admin';import LinearProgress from '@mui/material/LinearProgress';
import Box from '@material-ui/core/Box';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Typography from '@mui/material/Typography';

import { useTranslate, getLanguageFromStorage, getLocaleLang  } from '../common/language';
export const setActivePermissionData = (permission_id) => {
        
    var permissions = JSON.parse(localStorage.permissions);
    
    let indexPermission = 0;
    for (let i=0;i<permissions.length;i++)
    {
        if (permissions[i].id===permission_id)
        {
            indexPermission = i;
        }                
    }
                        
    if (permissions.length > 0)
    {
        localStorage.setItem('associations_id', permissions[indexPermission].associations_id );
        localStorage.setItem('associations_name', permissions[indexPermission].associations_name );  
        localStorage.setItem('friendly_url', permissions[indexPermission].friendly_url );  
        localStorage.setItem('permissions_groups', permissions[indexPermission].permissions_groups );
        localStorage.setItem('events_id', permissions[indexPermission].events_id );
        localStorage.setItem('events_name', permissions[indexPermission].events_name );
        localStorage.setItem('members_group_id', permissions[indexPermission].members_group_id );
        localStorage.setItem('members_pending_group_id', permissions[indexPermission].members_pending_group_id );
        localStorage.setItem('associations_logo_doc', permissions[indexPermission].associations_logo_doc  );
        localStorage.setItem('subscriptions', JSON.stringify( permissions[indexPermission].subscriptions ) );
        localStorage.setItem('active_permission', permissions[indexPermission].id );
    }

}
   
  
export const subscriptionModule = (module,option) => {
    
  let found = false;
    
  if (localStorage.active_permission && localStorage.active_permission > 0)  
  {        
        var permissions = JSON.parse(localStorage.permissions);
        
        let indexPermission = 0;
        for (let i=0;i<permissions.length;i++)
        {
            if (permissions[i].id==localStorage.active_permission)
            {
                indexPermission = i;
            }                
        }
      
        if (permissions[indexPermission])
        {
          if (option == null)
          {
            for (let item of permissions[indexPermission].subscriptions) {
              if (item.modules.public_id === module) found = true;
            }
          }
          else
          {
            for (let item of permissions[indexPermission].subscriptions) {
              if (item.modules.public_id === module && item.modules_options.public_id === option) found = true;
            }
          }
        }
  }
    
  return found;
};

export const dateEventByLang = (dateStart, dateFinish, translate, langId ) => {

  const dateStartDate = new Date(dateStart);
  const dateFinishDate = new Date(dateFinish);

  const sameDay =
    dateStartDate.getFullYear() === dateFinishDate.getFullYear() &&
    dateStartDate.getMonth() === dateFinishDate.getMonth() &&
    dateStartDate.getDate() === dateFinishDate.getDate();

  const locale = getLocaleLang(langId);

  // Nom del dia de la setmana amb date-fns
  const rawWeekday = format(dateStartDate, 'EEEE', { locale });

  // Funció per posar només la primera lletra en majúscula
  const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const weekday = capitalizeFirst(rawWeekday);

  if (!sameDay) {
    return (
      translate('common.date_from') +
      `${weekday}, ` +
      format(dateStartDate, "d 'de' MMMM 'de' yyyy", { locale }) +
      translate('common.date_to') +
      format(dateFinishDate, "d 'de' MMMM", { locale })
    );
  }

  // Mateix dia
  return (
    `${weekday}, ` +
    format(dateStartDate, "d 'de' MMMM 'de' yyyy", { locale })
  );
};

export const timeEventByLang = (dateStart,translate,langId) => {
    
  const dateStartDate = new Date(dateStart);   
  const locale = getLocaleLang(langId);
  return format(dateStartDate, '\'' + translate('common.time_to') + ' \'HH\':\'mm', { locale: locale });
};

export const dateOnlyToCatalan = (dateStart) => {
  
  if (dateStart)
  {
    const dateStartDate = new Date(dateStart);    
    return format(dateStartDate, 'dd/MM/yyyy', { locale: ca });
  }
  else
      return '';
};

export const dateAndTimeToCatalan = (dateStart) => {
  
  if (dateStart)
  {
    const dateStartDate = new Date(dateStart);    
    return format(dateStartDate, 'dd/MM/yyyy HH:mm', { locale: ca });
  }
  else
      return '';
};

export const dateAndTimeWithSecondsToCatalan = (dateStart) => {
  
  if (dateStart)
  {
    const dateStartDate = new Date(dateStart);    
    return format(dateStartDate, 'dd/MM/yyyy HH:mm:ss', { locale: ca });
  }
  else
      return '';
};


export const structArrayToIdList = (arrayStruct) => {
    var arrayIds = [];
    for (var i = 0; i < arrayStruct.length; i++) {
      arrayIds.push(arrayStruct[i].id);
    }
    return arrayIds.join(',');
}


export const dateParser = value => {      
    if (value == null || value === '') return '';        
    return toIsoString(new Date(value));
}

export const utcDateParser = value => {
    if (value == null || value === '') return '';
    return new Date(value).toISOString();
}
    
export const toIsoString = date => {    
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);
}

export const datesLastMonth = () => {
    
    // Obtener la fecha actual
    const today = new Date();
    
    // Obtener el primer día del mes pasado
    const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    
    // Obtener el último día del mes pasado
    const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    
    return {
        firstDayLastMonth: firstDayLastMonth,
        lastDayLastMonth: lastDayLastMonth
    };

}



export const LinearProgressWithLabel = props => {      
  let linearProgressValue = props.value > 100 ? 100 : props.value;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={linearProgressValue} className="donations_linear_progress" />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export const RemainingTime = ({nSeconds, remainText, agoText}) => {  
    
    const translate = useTranslate();  
        
    let days = Math.floor(nSeconds / ( 60 * 60 * 24));
    let hours = Math.floor(nSeconds / (60*60));
    let minutes = Math.floor(nSeconds / (60));
               
    let retValue = '';
    let remain = translate('public_donations_projects.remain');
    
    if (nSeconds > 2*60*60*24)
        retValue = days + ' ' + translate('donations_projects.days');
    else if (nSeconds > 60*60*24)
    {
        retValue = days + ' ' + translate('donations_projects.day');
        remain = translate('public_donations_projects.remain_1');
    }
    else if (nSeconds > 2*60*60)
        retValue = hours + ' ' + translate('donations_projects.hours');
    else if (nSeconds > 60*60)
    {
        retValue = hours + ' ' + translate('donations_projects.hour');
        remain = translate('public_donations_projects.remain_1');
    }
    else if (nSeconds > 2*60)
        retValue = minutes + ' ' + translate('donations_projects.minutes');
    else if (nSeconds > 60)
    {
        retValue = minutes + ' ' + translate('donations_projects.minute');
        remain = translate('public_donations_projects.remain_1');
    }
    else if (nSeconds > 1)
        retValue = nSeconds + ' ' + translate('donations_projects.seconds');
    else if (nSeconds > 0)
    {
        retValue = nSeconds + ' ' + translate('donations_projects.second');
        remain = translate('public_donations_projects.remain_1');
    }
    
    if (remainText && retValue.length )
    {        
        return (<><span className="fs-14 grey8">{remain}</span><br/><span className="fs-20 bold">{retValue}</span></>);
    }
    if (agoText && retValue.length )
    {        
        return (<><span className="fs-14 grey8">{translate('public_donations_projects.ago')} {retValue}</span></>);
    }
    
    return (<span>{retValue}</span>);
    
}

export const DateTimeField = props => {      
  
  const translate = useTranslate();  
              
  return (
    <FunctionField render={record => dateAndTimeToCatalan(record[props.source], translate) } label={props.label}  sortable={false}  />
  );
}

export const DateTimeSecondsField = props => {      
  
  const translate = useTranslate();  
              
  return (
    <FunctionField render={record => dateAndTimeWithSecondsToCatalan(record[props.source], translate) } label={props.label}  sortable={false}  />
  );
}

export const DatagridNoResults = props => {
    
    const translate = useTranslate(); 
    
    return (<center><br />{translate('reports.no_results')}<br /><br /></center>);
}

export const formatFloat = (number) => {
    return number.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}


export const CopyToClipboard = ({ ...props }) => {
  
  const notify = useNotify();
  const translate = useTranslate();  
    
  const handleClick = (textToCopy) => {        
          
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        notify(translate('utils.copy_clipboard_success'), 'success');
      })
      .catch(err => {
        notify(translate('utils.copy_clipboard_error'), 'error');
      });
      
  };
  
  return (
       <Button onClick={handleClick.bind(this, props.message )} label={props.label} startIcon={<ContentCopyIcon />} />
  );
  
}

export const isPublicPage = () => {    

    const publicRoutes = [
        '/public', '/forgot-password', '/reset-password', '/validate-sender', '/sign-up', '/login'
    ];

    const current = window.location.hash || '';
    
    //console.log('HASH=' + window.location.hash);
    
    return publicRoutes.some(path => current.includes(path));
};

export const headersAPIObjectAuth = () => ({
  'Accept': 'application/json', /* El que rebem de la API */
  'Content-Type': 'application/json', /* El que enviem a la API */
  /*'Access-Control-Allow-Origin': apiOrigin,*/
  'Authorization': localStorage.getItem('auth'), /* Codi autorització */
  'Accept-Language': getLanguageFromStorage(), /* Idioma */
  'Role': localStorage.getItem('active_permission') /* Rol d'usuari */
});

export const headersAPIDocAuth = () => ({
  'Accept': 'application/json', /* El que rebem de la API */
  'Authorization': localStorage.getItem('auth'), /* Codi autorització */
  'Accept-Language': getLanguageFromStorage(), /* Idioma */
  'Role': localStorage.getItem('active_permission') /* Rol d'usuari */
});

export const headersAPIObjectPublic = () => ({  
  'Content-Type': 'application/json', /* El que enviem a la API */
  'Accept-Language': getLanguageFromStorage(), /* Idioma */
});

